import type { NorwegianCounty } from '@saas/api-client';

export const NORWEGIAN_COUNTY_VALUES = [
	'AGDER',
	'AKERSHUS',
	'BUSKERUD',
	'FINNMARK',
	'INNLANDET',
	'MORE_OG_ROMSDAL',
	'NORDLAND',
	'OSLO',
	'ROGALAND',
	'TELEMARK',
	'TROMS',
	'TRONDELAG',
	'VESTFOLD',
	'VESTLAND',
	'OSTFOLD',
] as const satisfies readonly NorwegianCounty[];

const COUNTY_LABELS = {
	AGDER: 'Agder',
	AKERSHUS: 'Akershus',
	BUSKERUD: 'Buskerud',
	FINNMARK: 'Finnmark',
	INNLANDET: 'Innlandet',
	MORE_OG_ROMSDAL: 'Møre og Romsdal',
	NORDLAND: 'Nordland',
	OSLO: 'Oslo',
	ROGALAND: 'Rogaland',
	TELEMARK: 'Telemark',
	TROMS: 'Troms',
	TRONDELAG: 'Trøndelag',
	VESTFOLD: 'Vestfold',
	VESTLAND: 'Vestland',
	OSTFOLD: 'Østfold',
} satisfies Record<NorwegianCounty, string>;

export type CountyOption = {
	value: NorwegianCounty;
	label: string;
};

export const NORWEGIAN_COUNTY_OPTIONS: CountyOption[] = NORWEGIAN_COUNTY_VALUES.map((value) => ({
	value,
	label: COUNTY_LABELS[value],
}));

const COUNTY_SET: ReadonlySet<string> = new Set(NORWEGIAN_COUNTY_VALUES);

export const isNorwegianCounty = (value: string): value is NorwegianCounty => COUNTY_SET.has(value);

export type PostingPlace = {
	location: string;
	county: NorwegianCounty | null;
};

export const formatPostingPlace = ({ location, county }: PostingPlace): string =>
	county ? `${location} · ${COUNTY_LABELS[county]}` : location;
